<template>
  <vx-card :title="title">

    <div class="vx-row mb-6">
      <vs-button
        class="ml-4 mt-2"
        color="danger"
        icon-pack="feather"
        icon="icon-arrow-left"
        @click="handleBack()"
      >Back
      </vs-button>
    </div>

    <vs-tabs :value="active">
      <vs-tab label="Suppliers SKU">
        <Gir></Gir>
      </vs-tab>
    </vs-tabs>
  </vx-card>
</template>
<script>

import Gir from "./index.vue"

export default {
  props: {
    active: {
      type: Number,
    },
  },
  components: {
    Gir
  },
  data() {
    return {
      title: "Shelf Life Import GR & GIR",
    };
  },
  methods: {
    handleBack() {
      this.$vs.loading();
      this.$router.go(-1);
      this.$router.push({
          name: "shelf-life",
          params: {tab_order: 2}
      });
      this.$vs.loading.close();
    },
  }
};
</script>
